import { TFreshRecipe, isFreshRecipe } from "@api-clients/subscriptions";

import {
  ICatSubscriptionRecord,
  IGetCustomerCatsResponse,
} from "./types/cat-info.types";

export const getAllCatIds = (
  response: IGetCustomerCatsResponse,
): number[] => response.cats.map((cat) => cat.details.id);

export const getCatById = (
  response: IGetCustomerCatsResponse,
  id: number,
): ICatSubscriptionRecord | null => response.cats.find((cat) => cat.details.id === id) || null;

export const getCatRecipesNames = (
  response: IGetCustomerCatsResponse,
  id: number,
): TFreshRecipe[] => {
  const cat = getCatById(response, id);
  if (!cat) {
    return [];
  }
  return Object.entries(cat.subscription?.recipes ?? [])
    .filter(([ key, value ]) => value && value > 0 && isFreshRecipe(key))
    .map(([ key ]) => key as TFreshRecipe);
};
